/* eslint no-undef: 1 */
// @Todo : this is just for proof of concept
// Latter credentials will be requested from addon server


export const initializePickerApi = (credentials) => {
    const {
        developerKey = 'AIzaSyCEYulkZG4UDg3j7jviGwjV7EJW-gXW7KQ',
        clientId = '786161734510-ah7lj5rdvcb4vak9o4uj3vdrdg4hovtn.apps.googleusercontent.com',
        appId = '786161734510',
        pickerCallback,
        scope = ['https://www.googleapis.com/auth/drive'],
    } = credentials;

    let pickerApiLoaded = false;
    let oauthToken;

    // Create and render a Picker object for searching images.
    function createPicker() {
        if (pickerApiLoaded && oauthToken) {
            const docsView = new google.picker.DocsView()
                .setIncludeFolders(true)
                .setMimeTypes('application/vnd.google-apps.folder')
                .setSelectFolderEnabled(true);

            const picker = new google.picker.PickerBuilder()

                .setAppId(appId)
                .setOAuthToken(oauthToken)

                .addView(docsView)
                .addView(new google.picker.DocsUploadView())
                .setDeveloperKey(developerKey)
                .setCallback(pickerCallback)
                .build();
            picker.setVisible(true);
        }
    }

    function handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
            oauthToken = authResult.access_token;
            createPicker();
        }
    }

    function onAuthApiLoad() {
        gapi.auth.authorize(
            {
                client_id: clientId,
                scope,
                immediate: false,
            },
            handleAuthResult
        );
    }

    function onPickerApiLoad() {
        pickerApiLoaded = true;
        createPicker();
    }

    // Use the Google API Loader script to load the google.picker script.
    window.loadPicker = function loadPicker() {
        gapi.load('auth', { callback: onAuthApiLoad });
        gapi.load('picker', { callback: onPickerApiLoad });
    };

    window.loadPicker();
};
